/* Velmora theme — vanilla JS, no dependencies */
(function () {
  'use strict';

  var theme = window.VelmoraTheme || { routes: {}, strings: {}, ajaxCart: true };

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* ---------- Announcement bar: rotator, countdown, offset ---------- */
  function initAnnouncement() {
    var bar = $('[data-announcement]');
    if (!bar) return;

    var setOffset = function () {
      var sticky = bar.classList.contains('announcement-bar--sticky');
      document.documentElement.style.setProperty('--announcement-height', sticky ? bar.offsetHeight + 'px' : '0px');
    };
    setOffset();
    window.addEventListener('resize', setOffset);

    var messages = $$('.announcement-bar__message', bar);
    if (messages.length > 1) {
      var i = 0;
      setInterval(function () {
        messages[i].classList.remove('is-active');
        i = (i + 1) % messages.length;
        messages[i].classList.add('is-active');
      }, 4500);
    }

    var timeEl = $('[data-countdown-time]', bar);
    if (timeEl) {
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var now = new Date();
        var end = new Date(now); end.setHours(23, 59, 59, 999);
        var diff = Math.max(0, Math.floor((end - now) / 1000));
        timeEl.textContent = pad(Math.floor(diff / 3600)) + ':' + pad(Math.floor((diff % 3600) / 60)) + ':' + pad(diff % 60);
      };
      tick();
      setInterval(tick, 1000);
    }
  }

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var toggle = $('[data-menu-toggle]');
    var nav = $('#MobileNav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.hidden = open;
    });
  }

  /* ---------- Cart helpers ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  var toastTimer;
  function showToast() {
    var toast = $('#CartToast');
    if (!toast) return;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4000);
  }

  /* ---------- Product showcase ---------- */
  function initProduct(section) {
    var jsonEl = $('[data-product-json]', section);
    var form = $('form.product-form', section);
    if (!jsonEl || !form) return;

    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-to-cart]', form);
    var addText = $('[data-add-to-cart-text]', form);
    var priceEl = $('[data-price]', section);
    var compareEl = $('[data-compare-price]', section);
    var saveEl = $('[data-save]', section);
    var stickyPrice = $('[data-sticky-price]', section);
    var stickyBtn = $('[data-sticky-submit]', section);
    var errorEl = $('[data-form-error]', form);
    var fieldsets = $$('[data-option-index]', form);
    var isProductPage = document.body.classList.contains('template-product');

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      return product.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === options[i]; });
      });
    }

    function setButton(variant) {
      var label;
      if (!variant) { label = theme.strings.unavailable; addBtn.disabled = true; }
      else if (!variant.available) { label = theme.strings.soldOut; addBtn.disabled = true; }
      else { label = theme.strings.addToCart; addBtn.disabled = false; }
      addText.textContent = label;
      if (stickyBtn) { stickyBtn.textContent = label; stickyBtn.disabled = addBtn.disabled; }
    }

    function showMedia(mediaId) {
      if (!mediaId) return;
      $$('[data-media-id]', section).forEach(function (s) { s.classList.toggle('is-active', String(s.dataset.mediaId) === String(mediaId)); });
      $$('[data-thumb]', section).forEach(function (t) { t.classList.toggle('is-active', String(t.dataset.thumb) === String(mediaId)); });
    }

    function markAvailability(options) {
      // Grey out values that can't form an available variant with the other current selections
      fieldsets.forEach(function (fs, idx) {
        $$('input', fs).forEach(function (input) {
          var test = options.slice(); test[idx] = input.value;
          var match = findVariant(test);
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function onChange() {
      var options = selectedOptions();
      fieldsets.forEach(function (fs, i) {
        var out = $('[data-option-selected]', fs);
        if (out) out.textContent = options[i] || '';
      });
      var variant = findVariant(options);
      setButton(variant);
      markAvailability(options);
      if (errorEl) errorEl.hidden = true;
      if (!variant) return;

      idInput.value = variant.id;
      priceEl.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      compareEl.hidden = !onSale;
      saveEl.hidden = !onSale;
      if (onSale) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        saveEl.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price);
      }
      if (variant.featured_media) showMedia(variant.featured_media.id);

      if (isProductPage && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    fieldsets.forEach(function (fs) { fs.addEventListener('change', onChange); });
    if (fieldsets.length) markAvailability(selectedOptions());

    $$('[data-thumb]', section).forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(thumb.dataset.thumb); });
    });

    // Quantity stepper
    var qtyInput = $('.quantity__input', form);
    var minus = $('[data-qty-minus]', form);
    var plus = $('[data-qty-plus]', form);
    if (qtyInput && minus && plus) {
      minus.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });
    }

    // AJAX add to cart (falls back to native form post if disabled or on error)
    form.addEventListener('submit', function (e) {
      if (!theme.ajaxCart || !window.fetch) return;
      e.preventDefault();
      var original = addText.textContent;
      addBtn.disabled = true;
      addText.textContent = theme.strings.adding;

      fetch(theme.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error(r.data.description || r.data.message || 'Could not add to cart');
          return fetch(theme.routes.cart_js, { headers: { 'Accept': 'application/json' } }).then(function (res) { return res.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          showToast();
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        })
        .finally(function () {
          addBtn.disabled = false;
          addText.textContent = original;
        });
    });

    // Sticky add-to-cart bar visibility
    var sticky = $('[data-sticky-atc]', section);
    if (sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', visible);
          sticky.setAttribute('aria-hidden', String(!visible));
          if (stickyBtn) stickyBtn.tabIndex = visible ? 0 : -1;
        });
      });
      io.observe(addBtn);
    }
  }

  /* ---------- FAQ: one open at a time ---------- */
  function initAccordions() {
    $$('[data-accordion]').forEach(function (acc) {
      var items = $$('details', acc);
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) { if (other !== item) other.open = false; });
        });
      });
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.Shopify && Shopify.designMode) return; // keep everything visible in the theme editor
    var targets = $$('.feature-card, .step, .testimonial, .faq__item, .section-header-text');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-revealed'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -40px 0px' });
    targets.forEach(function (t) {
      if (t.getBoundingClientRect().top > window.innerHeight) { t.classList.add('js-reveal'); io.observe(t); }
    });
  }

  function init() {
    initAnnouncement();
    initMenu();
    $$('.product-showcase').forEach(initProduct);
    initAccordions();
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-init sections when edited in the Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.product-showcase');
    if (s) initProduct(s);
    initAccordions();
  });
})();
